import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { formatBalanceWithCommas, formatCryptoPrice, formatPercentage, formatValueWithCompactNumber } from '@/lib/format';
import { cn, genJudgingSizeColor } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TokenAvatar from '@/widget/TokenAvatar';
import NoData from '@/widget/NoData';
import HoldingRowSkeleton from './HoldingRowSkeleton';
import { useAppStore } from '@/store';
import { IHoldingPriceBalance } from '../../hooks/useHoldingData';

interface IProps {
  loading: boolean;
  holdingList: IHoldingPriceBalance[];
}
export default (props: IProps) => {
  const { loading, holdingList } = props;
  const { t } = useTranslation();
  const {
    chainInfo: { path },
  } = useAppStore();
  const navigate = useNavigate();

  return (
    <div>
      <Table className="w-full" wrapperClassName="text-[12px]">
        <TableHeader>
          <TableRow className="border-none text-[12px]">
            <TableHead className="w-[160px] pl-0">{t('Account.price')}</TableHead>
            <TableHead className="text-right">{t('Account.unrealizedProfit')}</TableHead>
            <TableHead className="text-right pr-0">{t('Account.balance')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <HoldingRowSkeleton />
          ) : (
            holdingList.map((token) => {
              return (
                <TableRow
                  className="border-borderColor hover:!bg-[unset]"
                  key={token.tokenAddress}
                  onClick={() => navigate(`/${path}/trade/${token.tokenAddress}`)}
                >
                  <TableCell className="pl-0">
                    <div className="flex items-center gap-x-[8px]">
                      <TokenAvatar logo="" address={token.tokenAddress} className="w-[30px] h-[30px]" />
                      <div>
                        <p>{token.symbol}</p>
                        <p>
                          <span>{formatCryptoPrice(token.price)}</span>&nbsp;·&nbsp;
                          <span className={cn(genJudgingSizeColor(token.priceChg))}>
                            {formatPercentage(token.priceChg, { showPositiveSign: true, scale: true })}
                          </span>
                        </p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="text-12px text-right">
                      <p className={genJudgingSizeColor(token.unrealizedPnl)}>{formatBalanceWithCommas(token.unrealizedPnl)}</p>
                      <p className={cn('text-secondaryTextColor', genJudgingSizeColor(token.unrealizedRoi))}>
                        {formatPercentage(token.unrealizedRoi, { scale: true })}
                      </p>
                    </div>
                  </TableCell>
                  <TableCell className="text-right pr-0">
                    <p>{formatValueWithCompactNumber(token.amount)}</p>
                    <p>{formatBalanceWithCommas(token.balance)}</p>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      {holdingList.length == 0 && !loading && <NoData />}
    </div>
  );
};
